module.exports = __webpack_public_path__ + "img/20190729161327QQ截图20190729010029.39e7fe0f.png";